import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=35bb8c18"
var script = {}
import style0 from "./Why.vue?vue&type=style&index=0&id=35bb8c18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports